import { handleCCEvent } from '@cc/calculator';

const ROOT_URL = process.env.NEXT_PUBLIC_BASE_URL;

const IFRAME_CLASS_NAME = 'calculator-frame';
const IFRAME_SANDBOX =
  'allow-same-origin allow-scripts allow-forms allow-popups allow-popups-to-escape-sandbox';
const IFRAME_TITLE = 'Calculator Frame';
const IFRAME_STYLE = 'border:none;';
const IFRAME_WIDTH = '100%';
const IFRAME_HEIGHT = '16rem';

const initFramedCalculator = ({ calculatorId, el }) => {
  const iFrame = createIframe(el, calculatorId);

  el.childNodes.forEach((child) => {
    if (child !== iFrame) {
      el.removeChild(child);
    }
  });

  // Send custom user defined attributes to the calculator,
  // so they can be added to the context and used in logic etc.
  window.addEventListener('message', (ev) => {
    if (ev.data?.calculatorId !== calculatorId) {
      return;
    }

    if (ev.data?.type === 'ready') {
      iFrame.contentWindow.postMessage(
        {
          calculatorId,
          type: 'embedParams',
          payload: getEmbedParams(el),
        },
        '*',
      );
    }
  });

  const ccEventListener = (ev) => {
    const { data = {} } = ev;

    const { calculatorId: eventCalculatorId, payload, type } = data;

    if (eventCalculatorId !== calculatorId) return;

    handleCCEvent({
      calculatorId,
      payload,
      type,
      context: { parentWindow: window, calculatorContainer: iFrame },
    });
  };

  window.addEventListener('message', ccEventListener);
};

const createIframe = (parent, calculatorId) => {
  const id = `calculator-frame-${calculatorId}`;
  const src = `${ROOT_URL}/embed/${calculatorId}`;

  const existingIframe = document.getElementById(id);

  if (existingIframe) {
    if (existingIframeIsCorrect(existingIframe, src)) {
      return existingIframe;
    }
    existingIframe.remove();
    console.error('[CC] existing iframe is not correct, creating a new one');
  }

  const iFrame = document.createElement('iframe');
  iFrame.className = IFRAME_CLASS_NAME;
  iFrame.id = id;
  iFrame.sandbox = IFRAME_SANDBOX;
  iFrame.title = IFRAME_TITLE;
  iFrame.style = IFRAME_STYLE;
  iFrame.width = IFRAME_WIDTH;
  iFrame.height = IFRAME_HEIGHT;
  iFrame.src = `${src}?url=${encodeURIComponent(window.location.href)}&framed=1`;

  parent.appendChild(iFrame);

  return iFrame;
};

const existingIframeIsCorrect = (iframe, src) => {
  if (iframe.className !== IFRAME_CLASS_NAME) {
    logIncorrectIframe('class');
    return false;
  }

  if (iframe.sandbox.value !== IFRAME_SANDBOX) {
    logIncorrectIframe('sandbox');
    return false;
  }

  if (iframe.title !== IFRAME_TITLE) {
    logIncorrectIframe('title');
    return false;
  }

  if (!iframe.src.startsWith(src)) {
    logIncorrectIframe('src');
    return false;
  }

  return true;
};

const logIncorrectIframe = (attr) => {
  console.error(`[CC] existing iframe has incorrect ${attr}`);
};

const getEmbedParams = (el) => {
  const EMBED_PARAM_PREFIX = 'embed';

  const params = {};

  Object.entries(el.dataset).forEach(([name, value]) => {
    if (typeof value === 'string' && name.startsWith(EMBED_PARAM_PREFIX)) {
      const paramName = name.slice(EMBED_PARAM_PREFIX.length).toLowerCase();
      params[paramName] = value;
    }
  });

  return params;
};

export default initFramedCalculator;
